import React from 'react'

import { getGlobal } from '../../util/global'

import * as Styled from './styles/SocialSharingBlock.styles'

const SocialSharingBlock = ({ description, title, url }) => {
  const global = getGlobal()

  const cleanTitle = title
    .replace(/&/g, '%26')
    .replace(/#/g, '%23')

  const shareTypes = {
    EMAIL: 'EMAIL',
    FACEBOOK: 'FACEBOOK',
    LINKED_IN: 'LINKED_IN',
    TWITTER: 'TWITTER'
  }

  const shareOptions = {
    FACEBOOK_SHARE_WINDOW_HEIGHT: 607,
    FACEBOOK_SHARE_WINDOW_WIDTH: 555,
    TWITTER_SHARE_WINDOW_HEIGHT: 380,
    TWITTER_SHARE_WINDOW_WIDTH: 540,
    WINDOW_MAX: 640
  }

  const shareUrls = () => ({
    [shareTypes.EMAIL]: `mailto:?&subject=${cleanTitle}&body=${description}%0D%0A%0D%0A${url}`,
    [shareTypes.FACEBOOK]: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    [shareTypes.LINKED_IN]: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${cleanTitle}&summary=${description}`,
    [shareTypes.TWITTER]: `https://twitter.com/home?status=${url} ${cleanTitle}`
  })

  const getShareUrl = (type) => shareUrls()[type]

  const openShareWindow = (type) => {
    const shareUrl = shareUrls()[type]
    const isSmallViewport = global?.innerWidth < shareOptions.WINDOW_MAX

    if (!isSmallViewport) {
      const shareWindowHeight = type === shareTypes.TWITTER
        ? shareOptions.TWITTER_SHARE_WINDOW_HEIGHT
        : shareOptions.FACEBOOK_SHARE_WINDOW_HEIGHT
      const shareWindowWidth = type === shareTypes.TWITTER
        ? shareOptions.TWITTER_SHARE_WINDOW_WIDTH
        : shareOptions.FACEBOOK_SHARE_WINDOW_WIDTH

      window.open(
        shareUrl,
        null,
        `toolbar=no,menubar=no,width=${shareWindowWidth},height=${shareWindowHeight}`
      )
    }

    else {
      document.location.href = shareUrl
    }
  }

  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.Title>
          Share
        </Styled.Title>
        <Styled.ShareIcon onClick={() => openShareWindow(shareTypes.FACEBOOK)}>
          <svg width='47' height='46' viewBox='0 0 47 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M23.2135 0C10.4162 0 0.0419922 10.2975 0.0419922 23C0.0419922 35.7025 10.4162 46 23.2135 46C36.0107 46 46.385 35.7025 46.385 23C46.385 10.2975 36.0107 0 23.2135 0ZM25.629 24.0103V36.5235H20.413V24.0108H17.8071V19.6987H20.413V17.1097C20.413 13.5918 21.8845 11.5 26.065 11.5H29.5455V15.8126H27.37C25.7426 15.8126 25.6349 16.4152 25.6349 17.5399L25.629 19.6982H29.5701L29.109 24.0103H25.629Z' fill='currentColor' />
          </svg>
        </Styled.ShareIcon>

        <Styled.ShareIcon onClick={() => openShareWindow(shareTypes.TWITTER)}>
          <svg width='48' height='46' viewBox='0 0 48 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M24.0038 0C11.2065 0 0.832275 10.2975 0.832275 23C0.832275 35.7025 11.2065 46 24.0038 46C36.801 46 47.1752 35.7025 47.1752 23C47.1752 10.2975 36.801 0 24.0038 0ZM23.3584 19.4903L23.3098 18.6944C23.1639 16.6317 24.4443 14.7477 26.4703 14.0168C27.2159 13.7569 28.4801 13.7244 29.3067 13.9518C29.6309 14.0493 30.2468 14.3741 30.6844 14.6664L31.4786 15.2024L32.3538 14.9263C32.8401 14.7801 33.4884 14.5365 33.7801 14.3741C34.0557 14.2279 34.2988 14.1467 34.2988 14.1954C34.2988 14.4715 33.6991 15.4136 33.1966 15.9333C32.5159 16.6642 32.7104 16.7292 34.0881 16.2419C34.9147 15.9658 34.9309 15.9658 34.7688 16.2744C34.6716 16.4368 34.1691 17.0053 33.6343 17.525C32.7266 18.4183 32.678 18.5158 32.678 19.2629C32.678 20.4161 32.1269 22.8199 31.5758 24.1355C30.5547 26.6042 28.3667 29.1542 26.1786 30.4373C23.0991 32.2401 18.9985 32.6949 15.5462 31.6392C14.3954 31.2819 12.418 30.3723 12.418 30.2099C12.418 30.1612 13.0177 30.0962 13.7471 30.08C15.2706 30.0475 16.7942 29.6252 18.0908 28.8781L18.966 28.3583L17.9611 28.0173C16.5348 27.53 15.2544 26.4093 14.9303 25.3536C14.833 25.0125 14.8654 24.9963 15.7731 24.9963L16.7131 24.98L15.9189 24.6065C14.9789 24.1355 14.1199 23.3396 13.6984 22.5275C13.3905 21.9428 13.0015 20.4648 13.115 20.3511C13.1474 20.3024 13.4877 20.3998 13.8767 20.5298C14.9951 20.9358 15.141 20.8384 14.4926 20.1562C13.277 18.9218 12.9043 17.0865 13.4877 15.3486L13.7633 14.569L14.833 15.6247C17.0211 17.7524 19.5981 19.0193 22.548 19.3928L23.3584 19.4903Z' fill='currentColor' />
          </svg>
        </Styled.ShareIcon>

        <Styled.ShareIcon onClick={() => openShareWindow(shareTypes.LINKED_IN)}>
          <svg width='47' height='46' viewBox='0 0 47 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M23.794 0C10.9968 0 0.622559 10.2975 0.622559 23C0.622559 35.7025 10.9968 46 23.794 46C36.5913 46 46.9655 35.7025 46.9655 23C46.9655 10.2975 36.5913 0 23.794 0ZM11.7464 19.0508H16.9975V34.7116H11.7464V19.0508ZM17.3435 14.2051C17.3094 12.6696 16.2032 11.5 14.4068 11.5C12.6104 11.5 11.436 12.6696 11.436 14.2051C11.436 15.7088 12.5757 16.912 14.3386 16.912H14.3722C16.2032 16.912 17.3435 15.7088 17.3435 14.2051ZM29.8893 18.6816C33.3448 18.6816 35.9354 20.9204 35.9354 25.7308L35.9352 34.7102H30.6842V26.3317C30.6842 24.2271 29.9243 22.7911 28.0234 22.7911C26.5726 22.7911 25.7085 23.7592 25.329 24.6943C25.1902 25.0294 25.1561 25.4963 25.1561 25.9643V34.7106H19.9043C19.9043 34.7106 19.9735 20.5193 19.9043 19.0498H25.1561V21.268C25.853 20.2017 27.1013 18.6816 29.8893 18.6816Z' fill='currentColor' />
          </svg>
        </Styled.ShareIcon>

        <Styled.ShareIconLink href={getShareUrl(shareTypes.EMAIL)} target='_blank'>
          <svg width='47' height='46' viewBox='0 0 47 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <ellipse cx='23.5843' cy='23' rx='23.1715' ry='23' fill='currentColor' />
            <path fillRule='evenodd' clipRule='evenodd' d='M35.338 15.9993C35.338 14.716 34.2802 13.666 32.9873 13.666H14.1814C12.8885 13.666 11.8307 14.716 11.8307 15.9993V29.9993C11.8307 31.2827 12.8885 32.3327 14.1814 32.3327H32.9873C34.2802 32.3327 35.338 31.2827 35.338 29.9993V15.9993ZM32.9873 15.9993L23.5843 21.8327L14.1814 15.9993H32.9873ZM23.5843 24.166L14.1814 18.3327V29.9993H32.9873V18.3327L23.5843 24.166Z' fill='#F2F6F8' />
          </svg>
        </Styled.ShareIconLink>
      </Styled.Content>
    </Styled.Container>
  )
}

export default SocialSharingBlock